export default {
	partnerStatus(state) {
		return state.partnerStatus
	},
	userTypes(state) {
		return state.userTypes
	},
	userSource(state) {
		return state.userSource
	}
}